// import staffManage from "./staffManage/config/routes";
// import productFootBath from './productFootBath/config/routes'; //快速开单
// import setMeal from './setMeal/config/routes'; //套餐开卡、划卡
// import paperRepair from './paperRepair/config/routes'; //修护开卡
// import memberManage from "./member/config/routes"; //会员充值、销卡
// import paperCard from "./paperCard/config/routes"; //纸质划卡
// import reserveInfo from "./reserveInfo/config/routes"; //预约泡脚

import collectMoney from "./collectMoney/index"; //快速开单
import manage from "./manage/index"; //快速开单
import datas from "./datas/index"; //快速开单
// import orderInfo from "./orderInfo/config/routes"; //订单列表
// import member from "./member/config/routes"; //订单列表

export default [
    //...staffManage,
    // ...productFootBath,
    // ...setMeal,
    // ...paperRepair,
    // ...memberManage,
    // ...paperCard,
    // ...reserveInfo,
    // ...member,
    ...collectMoney,
    // ...orderInfo,
    ...manage,
    ...datas,
];